import validate from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/node_modules/.pnpm/nuxt@3.10.3_@types+node@20.11.24_eslint@8.57.0_sass@1.71.1_stylelint@16.2.1_typescript@5.3.3_vite@5.1.4/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/middleware/auth.global.ts";
import client_45context_45global from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/middleware/client-context.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global,
  client_45context_45global
]
export const namedMiddleware = {
  "admin-only": () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/middleware/admin-only.ts"),
  capability: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/middleware/capability.ts"),
  disabled: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/middleware/disabled.ts"),
  "super-admin-only": () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/middleware/super-admin-only.ts"),
  "support-admin-only": () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/middleware/support-admin-only.ts"),
  "system-roles-manage": () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/middleware/system-roles-manage.ts")
}